import { Box, Skeleton, Slider, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import moment from "moment/moment";

import CustomAvatar from "../../CustomAvatar";
import RightLeftChecker from "./../../../../utils/RightLeftChecker";

const TitleSection = ({ data, topicUrl, cmLength }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.white.main,
        fontSize: "10px",
        alignItems: "center",
        margin: "16px 16px 4px 18px",
        position: "relative",
        mb: cmLength === 0 ? "" : "auto",
      }}
    >
      <Box
        onClick={() => navigate(topicUrl)}
        sx={{
          backgroundColor: theme.palette.white.main,
          display: "flex",
          minHeight: "96px",
          border: "2px solid",
          borderBottom: "6px solid",
          borderColor: theme.palette.black.main,
          borderRadius: "16px",
          overflowX: "hidden",
          padding: "16px 16px 16px 12px",
          fontSize: "10px",
          lineHeight: "14px",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <CustomAvatar
          src={data && (data.thumbnail ? data.thumbnail : data.author.avatar)}
          size={64}
          iconType={data?.content_type}
          iconSize={32}
          round={"8px"}
          alt={data?.author?.username}
        />
        <Box sx={{ width: "100%" }}>
          <Box
            style={{
              paddingBottom: "12px",
              fontWeight: "700",
              fontSize: "20px",
              lineHeight: "24px",
              direction: RightLeftChecker(data?.title) ? "rtl" : "ltr",
            }}
          >
            {data ? (
              data.title
            ) : (
              <Skeleton width={160} height={32} sx={{ mx: "8px" }} />
            )}
          </Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#757575",
              flexWrap: "wrap",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                maxWidth: "100px",
              }}
            >
              <Slider
                aria-label='timeline'
                min={0}
                max={1}
                step={0.001}
                value={data?.time_watched / data?.duration}
                sx={{
                  position: "absolute",
                  padding: "0 !IMPORTANT",
                  width: "100px",
                  ml: "8px",
                  color: "primary.main",
                  cursor: "default",
                  "& .MuiSlider-track": {
                    border: "none",
                  },
                  "& .MuiSlider-thumb": {
                    display: "none",
                  },
                  "& .MuiSlider-rail": {
                    backgroundColor: "blackDisabled.main",
                  },
                }}
              />
            </Box>
            {data ? (
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#757575",
                  padding: "6px 0",
                  fontSize: "12px",
                  textTransform: "uppercase",
                }}
              >
                {moment(data.created_at).format("DD/MM/YYYY") + " - "}

                {moment(data.created_at).format("h:mm a")}
              </Typography>
            ) : (
              <Skeleton width={100} height={15} />
            )}
          </Box>
        </Box>
      </Box>
      <Typography
        sx={{
          textAlign: "center",
          color: "#757575",
          fontWeight: "600",
          padding: "6px 0",
          fontSize: "12px",
        }}
      >
        Conversation started
      </Typography>
    </Box>
  );
};

export default TitleSection;
